import React, { useEffect, useState } from "react";
import qr_yape from "../assets/qr_yape.png";
import Swal from "sweetalert2";

const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzzCx-aBFZRPS8LDLll2GZcd-DOcwfPeGTB_kDGn9fVAbwjm5ZBgEjKaIB3G5WTMGcd/exec";

export const ModalPago = ({ show, onClose, onPagoRegistrado, datos }) => {
  const [nombreEmisor, setNombreEmisor] = useState("");

  const [numeroOperacion, setNumeroOperacion] = useState("");

  const [loading, setLoading] = useState(false);

  //=========================================
  // REINICIAR MODAL
  //=========================================

  useEffect(() => {
    if (show) {
      setNombreEmisor("");

      setNumeroOperacion("");

      setLoading(false);
    }
  }, [show]);

  //=========================================
  // REGISTRAR PAGO
  //=========================================

  const registrarPago = async (e) => {
    e.preventDefault();

    //=========================================
    // VALIDAR NOMBRE EMISOR
    //=========================================

    if (nombreEmisor.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Campo obligatorio",
        text: "Ingrese el nombre del emisor.",
      });

      return;
    }

    //=========================================
    // VALIDAR NÚMERO OPERACIÓN
    //=========================================

    if (numeroOperacion.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Campo obligatorio",
        text: "Ingrese el número de operación.",
      });

      return;
    }

    try {
      setLoading(true);

      //=========================================
      // ENVIAR PAGO A GOOGLE APPS SCRIPT
      //=========================================

      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",

        mode: "no-cors",

        headers: {
          "Content-Type": "text/plain",
        },

        body: JSON.stringify({
          accion: "pago",

          documento: datos.documento,

          nombreEmisor: nombreEmisor,

          numeroOperacion: numeroOperacion,

          monto: "",
        }),
      });

      //=========================================
      // LIMPIAR FORMULARIO
      //=========================================

      setNombreEmisor("");

      setNumeroOperacion("");

      //=========================================
      // TOAST DE ÉXITO
      // APARECE ARRIBA A LA DERECHA
      //=========================================

      Swal.fire({
        icon: "success",

        title: "¡Pago registrado correctamente!",

        toast: true,

        position: "top-end",

        showConfirmButton: false,

        timer: 1800,

        timerProgressBar: true,

        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },

        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
      });

      //=========================================
      // AVISAR A MODALREGISTRO
      //=========================================

      // Cerrará ModalPago
      // y abrirá ModalConfirmacionPago

      if (onPagoRegistrado) {
        setTimeout(() => {
          onPagoRegistrado();
        }, 300);
      }
    } catch (error) {
      console.error("Error al registrar pago:", error);

      //=========================================
      // TOAST DE ERROR
      //=========================================

      Swal.fire({
        icon: "error",

        title: "Error al registrar el pago",

        text: "No se pudo completar el registro del pago.",

        toast: true,

        position: "top-end",

        showConfirmButton: false,

        timer: 3500,

        timerProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };

  //=========================================
  // SI EL MODAL NO ESTÁ ACTIVO
  //=========================================

  if (!show) {
    return null;
  }

  //=========================================
  // RENDER
  //=========================================

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",

        background: "rgba(0,0,0,.6)",

        zIndex: 1055,
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          maxWidth: "650px",

          width: "92%",
        }}
      >
        <div
          className="modal-content border-0 shadow-lg"
          style={{
            borderRadius: "25px",

            overflow: "hidden",
          }}
        >
          {/*================================
              HEADER
          =================================*/}

          <div
            className="text-white p-4"
            style={{
              background: "linear-gradient(135deg,#44296a 0%,#370a33 100%)",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h3 className="fw-bold mb-1">Registrar Pago</h3>

                <p className="mb-0">Complete los datos del depósito.</p>
              </div>

              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
              />
            </div>
          </div>

          {/*================================
              FORMULARIO
          =================================*/}

          <form onSubmit={registrarPago}>
            <div className="modal-body p-4">
              {/* DATOS PARTICIPANTE */}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">Nombre</label>

                  <input
                    className="form-control form-control-lg rounded-4"
                    value={datos?.nombre || ""}
                    readOnly
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">Documento</label>

                  <input
                    className="form-control form-control-lg rounded-4"
                    value={datos?.documento || ""}
                    readOnly
                  />
                </div>
              </div>
              <div
                className="alert alert-secondary rounded-4 importante"
                style={{ fontSize: "1.1rem" }}
              >
                {" "}
                <p className="text-white mb-2">
                  {" "}
                  <span className="fw-bold"> ✓ </span> Aprovecha, estamos en
                  Precio Regular hasta el 11 de Diciembre del 2026.{" "}
                </p>{" "}
                <p className="text-white mb-2">
                  {" "}
                  <span className="fw-bold"> ✓ </span> El importe no es
                  reembolsable, pero será descontado del costo total del
                  Campamento.{" "}
                </p>{" "}
                <p className="text-white mb-2">
                  {" "}
                  <span className="fw-bold"> ✓ </span> El código QR obedece al
                  nombre de: ROGER RODRIGUEZ, Director de TMIP.{" "}
                </p>{" "}
                <p className="text-white mb-2">
                  {" "}
                  <span className="fw-bold"> ✓ </span> Al termino de su registro
                  le llegara a su whatsapp 4 archivos de información{" "}
                </p>{" "}
              </div>

              {/*================================
                  INFORMACIÓN DEL PAGO
              =================================*/}

              <div
                className="rounded-4 p-4 mb-4 text-center"
                style={{
                  background: "#faf7fc",

                  border: "1px solid #eadcf5",
                }}
              >
                <p
                  className="small mb-0"
                  style={{
                    color: "#080202",
                    lineHeight: "1.6",
                    fontSize: "1.1rem",
                  }}
                >
                  Escanea el código QR y realiza el depósito para
                  separar tu cupo de participación o el pago total de la
                  inscripción por los 34 días : Arequipa (425.00s/) Tumbes,
                  Tacna, Puno (450.00s/). Luego ingresa el nombre del emisor y
                  el numero de operación, verificalo en el yape para confirmar
                  tu pago{" "}
                </p>
                <br></br> 
                <h5
                  className="fw-bold"
                  style={{
                    color: "#9b2a92",
                  }}
                >
                  Separa tu cupo - Pago Inicial
                </h5>

                <h2
                  className="fw-bold"
                  style={{
                    color: "#3d1042",
                  }}
                >
                  S/ 30.00
                </h2>

                <img
                  src={qr_yape}
                  alt="QR Yape"
                  className="img-fluid rounded shadow-sm"
                  style={{
                    maxWidth: "190px",
                  }}
                />
              </div>
              {/*================ AVISO =================*/}

              {/*================================
                  NOMBRE EMISOR
              =================================*/}

              <div className="mb-3">
                <label className="form-label fw-bold">Nombre del Emisor</label>

                <input
                  className="form-control form-control-lg rounded-4"
                  placeholder="Ingresa el nombre del emisor que figura en el Yape"
                  value={nombreEmisor}
                  onChange={(e) => setNombreEmisor(e.target.value)}
                />
              </div>

              {/*================================
                  NUMERO OPERACIÓN
              =================================*/}

              <div className="mb-4">
                <label className="form-label fw-bold">
                  Número de Operación
                </label>

                <input
                  className="form-control form-control-lg rounded-4"
                  placeholder="Ingresa el número de operación"
                  value={numeroOperacion}
                  onChange={(e) => setNumeroOperacion(e.target.value)}
                />
              </div>
            </div>

            {/*================================
                FOOTER
            =================================*/}

            <div className="modal-footer border-0 pb-4">
              <button
                type="button"
                className="btn btn-secondary rounded-pill px-4"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>

              <button
                type="submit"
                className="btn text-white rounded-pill px-5"
                disabled={loading}
                style={{
                  background: "linear-gradient(135deg,#9b2a92,#3d1042)",

                  border: "none",
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Guardando...
                  </>
                ) : (
                  "Registrar Pago"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
